import { LiCommentMessage } from "types/conversationInbox";
import { NormalMessage, NormalMessageProps } from "./normal-message";
import { renderContentProps } from "./types";
import { cn } from "@/lib/utils";

type Props = Pick<renderContentProps, "originalMessage"> & NormalMessageProps;
export const LiComment = (props: Props): JSX.Element => {
  const liComment = props.originalMessage as LiCommentMessage | undefined;
  const imgUrl = liComment?.content?.[0]?.url;
  const message = props.message || (imgUrl && "Shared an image") || "";
  return (
    <>
      {imgUrl && (
        <img
          className={cn(
            "w-[200px] h-[200px] bg-inbox-surface-sunken shrink-0 object-contain mx-4",
            !props.isLeft && "self-end"
          )}
          alt="Attachment Preview Image"
          src={imgUrl}
        />
      )}
      <NormalMessage {...props} message={message} />
    </>
  );
};
